import { Button, Spin } from "antd";
interface ReportPageProps {
  isLoading: boolean;
  children: React.ReactNode;
}

const ReportPage = ({ isLoading, children }: ReportPageProps) => {
  return (
    <>
      {isLoading ? (
        <div className="flex flex-row items-center w-[500px] h-[500px] mx-auto my-[6rem]">
          <Spin
            className="spiner-loading-soil"
            style={{ margin: "auto" }}
            size="large"
          />
        </div>
      ) : (
        <div className="section-container flex flex-col items-center justify-center w-[720px] mx-auto !bg-white">
          <div
            id="pages-wrapper"
            className=" flex flex-col justify-center items-center w-full mx-auto bg-white"
          >
            {children}
          </div>

          <div className="flex flex-col">
            <Button
              className="button-neo h-fit !text-[#333] hover:brightness-105 fixed top-[20px] right-[100px] max-lg:right-[32px] px-8 text-[18px]  w-[150px]"
              id="download-button"
              onClick={() => window.print()}
            >
              پرینت گزارش
            </Button>
            <Button
              className="button-neo h-fit !text-[#333] hover:brightness-105 fixed top-[65px] right-[100px] max-lg:right-[32px] px-8 text-[18px] w-[150px]"
              id="download-button"
              onClick={() => window.close()}
            >
              بازگشت
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default ReportPage;
